import React from 'react';
import { Grid, SectionHeader } from '@benzinga/core-ui';
import { NewsCard } from './NewsCard';
import styled from '@benzinga/themetron';
import { News, StoryObject } from '@benzinga/basic-news-manager';

export interface NewsGridProps {
  nodes: News[] | StoryObject[];
  subtitle?: string;
  title?: string;
  link?: string;
}

export const NewsGrid: React.FC<NewsGridProps> = ({ link, nodes, subtitle, title }) => {
  let gridCols = nodes.length;
  if (nodes.length >= 6) {
    nodes = nodes.slice(0, 6);
    gridCols = 3;
  }

  return (
    <NewsGridWrapper>
      <SectionHeader
        bordered={true}
        level={2}
        rightSlot={link && <span className="see-more">See more</span>}
        subtitle={subtitle}
        title={title}
        url={link}
      />
      <Grid columnsSize={{ lg: gridCols, md: 3, sm: 2 }} maxColumns={gridCols}>
        {nodes.map((story, i) => {
          return <NewsCard contentId={title} key={i} node={story} size="compact" />;
        })}
      </Grid>
    </NewsGridWrapper>
  );
};

const NewsGridWrapper = styled.div`
  margin-top: 1rem;
`;
